document.addEventListener('DOMContentLoaded', function () {
    new Splide('#blog-slider', {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false
    }).mount();
    
    document.querySelectorAll('.youtube-thumbnail').forEach(function (element) {
      element.addEventListener('click', function () {
        var videoId = this.getAttribute('data-video-id');
        var iframe = document.getElementById('youtubeFrame');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
        var modal = document.getElementById('youtubeModal');
        modal.style.display = 'block';
      });
    });
    
    var modal = document.getElementById('youtubeModal');
    var closeBtn = document.querySelector('.youtube-modal .close');
    var iframe = document.getElementById('youtubeFrame');

    closeBtn.addEventListener('click', function () {
      iframe.src = '';
      modal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target == modal) {
        iframe.src = '';
        modal.style.display = 'none';
      }
    });
  });